symbolLandAnimator = {};
symbolLandAnimator.animationPool = [
  {
    poolName: "Empty",
    number: 0,
    pool: [],
    anims: [],
    backings: [],
  },
];
symbolLandAnimator.currentAnimations = [];
symbolLandAnimator.gameReels = undefined;
symbolLandAnimator.slotContainer = undefined;
symbolLandAnimator.ready = false;
symbolLandAnimator.finishedCallback = undefined;
symbolLandAnimator.completeCallback = undefined;

symbolLandAnimator.symbolIDMap = [
  { id: 14, name: "Jacuzzi", anim: 0, scale: 1 },
  { id: 15, name: "Respin", anim: 0, scale: 1 },
  { id: 16, name: "Respin", anim: 1, scale: 1 },
  { id: 17, name: "Respin", anim: 2, scale: 1 },
];

symbolLandAnimator.initialise = function () {
  symbolLandAnimator.gameReels = gameData.reels;
  symbolLandAnimator.slotContainer = resourceManager.get("slotContainer:reelContainer");
  symbolLandAnimator.backingContainer = resourceManager.get("slotContainer:reelContainer:backingContainer");

  symbolLandAnimator.createPoolAnim("Fisherman", 0, ["Fisherman_Regular", "Fisherman_Regular", "Fisherman_Regular"]);
  symbolLandAnimator.createPoolAnim("Respin", 0, ["Respin_Plus_1", "Respin_Plus_2", "Respin_Plus_3"]);
  Reflex.addToUpdate(function () {
    symbolLandAnimator.update();
  });
  symbolLandAnimator.ready = true;
};

symbolLandAnimator.createPoolAnim = function (name, index, animNames = undefined) {
  let spineAnim = undefined;
  let backings = [];

  let animNamesCheck = animNames;

  let found = false;

  //Search for pool name
  for (let i = 0; i < symbolLandAnimator.animationPool.length; i++) {
    let poolType = symbolLandAnimator.animationPool[i];

    //If pool name exists add a new anim there
    if (poolType.poolName === name) {
      found = true;

      animNamesCheck = poolType.anims;

      spineAnim = resourceManager.createObject("spine", "Land" + name + index, symbolLandAnimator.slotContainer, {
        name: name,
        defaultAnimation: animNamesCheck[0],
        scaleX: 1,
        scaleY: 1,
      });

      //create backings

      for (let i = 0; i < poolType.backingPool.fileNames.length; i++) {
        const backingFileName = poolType.backingPool.fileNames[i];

        const backing = resourceManager.createObject(
          "sprite",
          name + index + "LandBacking" + i,
          symbolLandAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
      }

      poolType.pool.push(spineAnim);
      poolType.number++;
      poolType.backingPool.pool.push([backings]);

      break;
    }
  }

  if (!found) {
    //Otherwise create a new anim pool with this name
    spineAnim = resourceManager.createObject("spine", "Land" + name + index, symbolLandAnimator.slotContainer, {
      name: name,
      defaultAnimation: animNamesCheck[0],
      scaleX: 1,
      scaleY: 1,
    });

    //create backings
    const fileNames = [];

    for (let i = 0; i < animNamesCheck.length; i++) {
      const symbolIdOffset = i * 20;
      const backingFileName = symbolLandAnimator.getSymbolBackingFileName(14 + symbolIdOffset);

      const backing = resourceManager.createObject(
        "sprite",
        name + index + "LandBacking" + i,
        symbolLandAnimator.backingContainer,
        {
          fileName: backingFileName,
          scale: 1,
          anchor: 0.5,
        }
      );
      backing.visible = false;
      backings.push(backing);
      fileNames.push(backingFileName);
    }

    symbolLandAnimator.animationPool.push({
      poolName: name,
      number: 0,
      pool: [spineAnim],
      anims: animNamesCheck,
      backingPool: {
        pool: [backings],
        fileNames: fileNames,
      },
    });
  }

  spineAnim.visible = false;

  return { spine: spineAnim, backings: backings };
};

symbolLandAnimator.findSpineAndBacking = function (symbolId) {
  let spine = undefined;
  let location = 0;
  symbolId = symbolId % 20;

  const findSpineAnimName = symbolLandAnimator.symbolIDMap.find((symbolInfo) => symbolInfo.id === symbolId);
  let spineAnimName = findSpineAnimName.name;

  for (let i = 0; i < symbolLandAnimator.animationPool.length; i++) {
    let poolType = symbolLandAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        spine = poolType.pool[0];
        backings = poolType.backingPool.pool[0];

        poolType.pool.splice(0, 1);
        poolType.backingPool.pool.splice(0, 1);
        return { spine: spine, backings: backings };
      }
    }
  }

  spineAndbackings = symbolLandAnimator.createPoolAnim(spineAnimName, number + 1);
  symbolLandAnimator.animationPool[location].pool.pop();
  symbolLandAnimator.animationPool[location].backingPool.pool.pop();

  return spineAndbackings;
};

symbolLandAnimator.animate = function (symbols, callback, callBackDelay) {
  symbolLandAnimator.finishedCallback = callback;
  symbolLandAnimator.callBackDelay = callBackDelay;

  for (let i = 0; i < symbols.length; i++) {
    let symbol = symbols[i];

    symbolLandAnimator.animateSymbol(symbol);
  }
};

symbolLandAnimator.animateSymbol = function (symbol) {
  const id = symbol.symbolId % 20;
  let sizeOffset = Math.floor(symbol.symbolId / 20);
  const reel = symbol.cell.reel;
  const row = symbol.cell.row;

  let symbolMapIndex = symbol.symbolId;

  let spineAndBacking = symbolLandAnimator.findSpineAndBacking(symbolMapIndex);

  if (spineAndBacking === undefined) {
    return;
  }

  let animNum;
  let size = 1 * sizeOffset;

  switch (id) {
    // respin +1
    case 15:
      animNum = 0;
      size = 0;
      break;
    // respin +2
    case 16:
      animNum = 1;
      size = 1;
      break;
    // respin +3
    case 17:
      animNum = 2;
      size = 2;
      break;
    default:
      animNum = size;
      break;
  }

  let animNames = symbolLandAnimator.findAnimNames(id);

  let symbolToHide = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  symbolToHide.visible = false;
  const spine = spineAndBacking.spine;
  const backing = spineAndBacking.backings[size];

  backing.visible = true;

  let animationObject = {
    anim: spine,
    reel: reel,
    row: row,
    backing: backing,
    symbolToHide: symbolToHide,
  };

  symbolLandAnimator.currentAnimations.push(animationObject);

  symbolLandAnimator.positionAnim(animationObject);

  spine.visible = true;
  spine.anim = animNames[animNum];
  spine.play(animNames[animNum], false, 0, () => {
    symbolLandAnimator.animationFinished(animationObject);
    symbolLandAnimator.returnToPool(spine.Props.name, spine, spineAndBacking.backings);
    symbolToHide.visible = true;
  });
};

symbolLandAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.visible = false;
    animationObject.backing.visible = false;
    animationObject.symbolToHide.visible = true;
    symbolLandAnimator.currentAnimations.splice(symbolLandAnimator.currentAnimations.indexOf(animationObject), 1);
  }

  if (symbolLandAnimator.currentAnimations.length === 0) {
    if (symbolLandAnimator.finishedCallback) {
      if (symbolLandAnimator.callBackDelay !== undefined) {
        symbolLandAnimator.completeCallback = symbolLandAnimator.finishedCallback;
        timerManager.addTimeout(symbolLandAnimator.callBackDelay, function () {
          if (symbolLandAnimator.completeCallback) {
            symbolLandAnimator.completeCallback();
          }
        });
      } else {
        symbolLandAnimator.finishedCallback();
      }
    }
  }
};

symbolLandAnimator.findAnimNames = function (symbolId) {
  const findSpineAnimName = symbolLandAnimator.symbolIDMap.find((symbolInfo) => symbolInfo.id === symbolId);
  const spineAnimName = findSpineAnimName.name;

  for (let i = 0; i < symbolLandAnimator.animationPool.length; i++) {
    let poolType = symbolLandAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      animNames = poolType.anims;
      return animNames;
    }
  }

  return undefined;
};

symbolLandAnimator.update = function () {
  symbolLandAnimator.currentAnimations.forEach((animation) => {
    symbolLandAnimator.positionAnim(animation);
  });
};

symbolLandAnimator.returnToPool = function (name, spine, backings) {
  for (let index = 0; index < backings.length; index++) {
    const backing = backings[index];
    backing.visible = false;
  }

  for (let i = 0; i < symbolLandAnimator.animationPool.length; i++) {
    let poolType = symbolLandAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(spine);
      poolType.backingPool.pool.push(backings);
    }
  }
};

symbolLandAnimator.positionAnim = function (animationObject) {
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const reelObject = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const reelScale = reelObject.scale.x;

  symbol = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  const symbolPos = helper.getLocalFromGlobalPosition(symbol, anim);

  anim.position.set(symbolPos.x, symbolPos.y);
  anim.scale.set(reelScale);
  animationObject.backing.position.set(symbolPos.x, symbolPos.y);
  animationObject.backing.scale.set(reelScale / 2);
};

symbolLandAnimator.getSymbolBackingFileName = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);

  switch (sizeOffset) {
    case 0:
      return "Symbols/symbolstatics/x3/BACK_BORDER_x3.png";
    case 1:
      return "Symbols/symbolstatics/x4/BACK_BORDER_x4.png";
    case 2:
      return "Symbols/symbolstatics/x5/BACK_BORDER_x5.png";
    case 3:
      return "Symbols/symbolstatics/x6/BACK_BORDER_x6.png";
    case 4:
      return "Symbols/symbolstatics/x7/BACK_BORDER_x7.png";
  }
  return "Symbols/symbolstatics/x3/BACK_BORDER_x3.png";
};

symbolLandAnimator.skip = function () {
  symbolLandAnimator.currentAnimations.forEach((animation) => {
    animation.anim.visible = false;
    animation.backing.visible = false;
    animation.symbolToHide.visible = true;
  });

  symbolLandAnimator.currentAnimations = [];
  symbolLandAnimator.finishedCallback = undefined;
  symbolLandAnimator.completeCallback = undefined;
};

symbolLandAnimator.orientationChange = function () {
  if (symbolLandAnimator.ready) {
    symbolLandAnimator.currentAnimations.forEach((animation) => {
      animation.anim.visible = false;
      animation.backing.visible = false;
      animation.symbolToHide.visible = true;
    });
  }
};

Reflex.registerEventHandler("orientationChange", symbolLandAnimator.orientationChange);
